/* eslint-disable */
import React, { Component, } from "react";
import { reduxForm, } from "redux-form";
import { LayoutComponent_Text, } from "ggApp/modules/layout";
import { TranslatorComponent_Text as Translator, } from "ggApp/modules/translator";
import { AuthComponent_PhoneVerification, } from "ggApp/modules/auth";
import ggForm from "ggApp/modules/form";

const { phoneVerificationValidation, } = ggForm.validations;

const FormName = "profileConfirmPhone";

@reduxForm({
    getFormState: ggForm.selectors.reduxForm,
    form: FormName,
    enableReinitialize: true,
    validate: values => {
        const errors = {};

        errors.phone = phoneVerificationValidation(values.phone || {});

        return errors;
    },
})
export default class ProfileFormConfirmPhone extends Component {
    static defaultProps = {
        onSuccessVerification: () => {},
    }

    constructor(props) {
        super(props);

        this.state = {
            isSuccessCallbackHadCalled: false,
        }
    }

    renderNothingWithSuccessCallback = () => {
        const { isSuccessCallbackHadCalled, } = this.state;
        const { onSuccessVerification, } = this.props;

        if (!isSuccessCallbackHadCalled) {
            this.setState({
                isSuccessCallbackHadCalled: true,
            }, () => {
                onSuccessVerification();
            });
        }

        return null;
    };

    render() {
        const {
            onSubmit,
            updatePhone,
            confirmPhone,
            authFetching,
            initialValues,
            authPhoneVerification,
            theme,
            handleSubmit,
            error,
        } = this.props;

        return !initialValues.phone.isVerified ? (
            <form onSubmit={handleSubmit(onSubmit)}>
                <AuthComponent_PhoneVerification
                    dark={theme === "dark"}
                    namesUpdate={[
                        "phone.code",
                        "phone.number",
                        "phone.isVerified",
                    ]}
                    namesConfirm={[
                        "phone.isVerified",
                        "phone.verificationCode",
                    ]}
                    authPhoneVerification={authPhoneVerification}
                    formName={FormName}
                    updatePhone={updatePhone}
                    confirmPhone={confirmPhone}
                    authFetching={authFetching}
                />

                {!!error && (
                    <LayoutComponent_Text mini error>
                        {error}
                    </LayoutComponent_Text>
                )}

                <LayoutComponent_Text mini lightWeight white={theme === "dark"}>
                    <Translator tk="FORM_MANDATORY_FIELDS" />
                </LayoutComponent_Text>
            </form>
        ) : (
            this.renderNothingWithSuccessCallback()
        );
    }
}
